import React from 'react';

const IconCalendarClock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23.843" height="21.194" viewBox="0 0 23.843 21.194">
    <path id="calendar-clock" d="M18.545,4.636a1.987,1.987,0,0,0-1.987-1.987H14.571V1.287a1.325,1.325,0,0,0-2.649,0V2.649h-5.3V1.287a1.325,1.325,0,0,0-2.649,0V2.649H1.987A1.987,1.987,0,0,0,0,4.636V6.623H18.545Zm-.662,4.636a5.961,5.961,0,1,0,5.961,5.961A5.957,5.957,0,0,0,17.882,9.272ZM19.869,15.9H17.624a.405.405,0,0,1-.4-.4v-2.91a.662.662,0,1,1,1.325,0v1.987h1.325a.662.662,0,0,1,0,1.325ZM10.6,15.233a7.286,7.286,0,0,1,7.285-7.285H0V19.207a1.987,1.987,0,0,0,1.987,1.987H13.7A7.27,7.27,0,0,1,10.6,15.233Z" fill="#1d3853" />
  </svg>

);
export default IconCalendarClock;
